// extracted by mini-css-extract-plugin
export default {"app":"App_app__zr1wm","fullscreenContainer":"App_fullscreenContainer__OC+Ns","header":"App_header__fhC8n","neonAnim":"App_neonAnim__iBgw3","content":"App_content__wwONY"};